import { useCallback, useEffect, useState } from "react";

import { leadsApi } from "../services";
import { toastError, toastSuccess } from "../../../common/utils/toast";
import useDebounce from "./useDebounce";

export default function useLeads(initialFilters = {}) {

    const [loading, setLoading] = useState(false);

    const [leads, setLeads] = useState([]);
const [

    filters,

    setFilters

]=useState({

    q:"",

    status:"",

    loan_type:"",

    page:1,

    limit:20

,  ...initialFilters

    });
    const [

    pagination,

    setPagination

]=useState({

    page:1,

    limit:20,

    total:0,

    totalPages:0

});
const debouncedSearch=

    useDebounce(

        filters.q,

        300

    );
    const load = useCallback(

        async (customFilters = filters) => {

            try {

                setLoading(true);

                const response =
                    await leadsApi.getLeads(
                        {...customFilters, q:debouncedSearch}
                    );
                setLeads(
                    response?.items || []
                );

setPagination({

    page:

        response.page,

    limit:

        response.limit,

    total:

        response.total,

    totalPages:

        response.totalPages

});

            } finally {

                setLoading(false);

            }

        },

        [

    debouncedSearch,

    filters.status,

    filters.loan_type,

    filters.page,

    filters.limit
]

    );

    useEffect(() => {

        load();

    }, [load]);

    async function refresh() {

        await load(filters);

    }

    async function search(q) {

        setFilters(

            previous => ({

                ...previous,

                q

            })

        );

    }

    async function createLead(payload) {

        const response =
            await leadsApi.createLead(
                payload
            );

        await refresh();
     toastSuccess(

"Lead Created"

);
        return response?.data;
   

    }

    async function updateLead(id, payload) {

        const response =
            await leadsApi.updateLead(
                id,
                payload
            );

        await refresh();
toastSuccess(

"Lead Updated"

);
        return response.data;

    }

    async function deleteLead(id) {

        await leadsApi.deleteLead(id);
      toastError(

"Lead Deleted"

);
        await refresh();

    }

    return {

        loading,

        leads,

        filters,pagination,

        setFilters,

        load,

        refresh,

        search,

        createLead,

        updateLead,

        deleteLead

    };

}